export const timeslotsSwiperWrapperStyles = { display: 'flex', alignItems: 'center' };

export const timeSlotsSwiperChipTimeStyles = {
	width: '100%',
	height: 'initial',
	padding: '8px 0',

	'& span': {
		textOverflow: 'clip',
	},
};

export const timeslotsSwiperTimeslotCheckIconStyles = {
	position: 'absolute',
	top: 2,
	right: 2,
	margin: '0 !important',
	width: '12px !important',
	height: '12px !important',
};
